import { useNavigate } from "react-router-dom";
import Seo from "../components/Seo";
import "../components/booth/tokens.css";
import BoothMark from "../components/booth/BoothMark";
import PrivacyPolicyContent from "../components/booth/PrivacyPolicyContent";
import Footer from "../components/booth/Footer";
import "./Legal.css";

function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="booth booth-legal-page">
      <Seo
        title="Privacy policy — The Booth"
        description="How The Booth collects, uses, and protects your data when you connect your fantasy football league."
        path="/privacyPolicy"
      />
      <header className="booth-shell booth-legal-masthead">
        <a
          href="/"
          className="booth-legal-mark-link"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          <BoothMark />
        </a>
      </header>
      <main className="booth-shell booth-legal-main">
        <PrivacyPolicyContent />
      </main>
      <Footer />
    </div>
  );
}

export default Privacy;
